import React from 'react';
import { SitecoreImageField, SitecoreLinkField } from 'components/sitecore-fields';
import CircularProgress from '@material-ui/core/CircularProgress';


class FullSizeHeroBanner extends React.Component {
    render() {
        const {
            title,
            subtitle,
            desktopImage,
            desktopVideo,
            mobileImage,
            mobileVideo,
            cta1,
            cta2
        } = this.props.options;

        const venueBannerRandomID = 'venue-banner-' + (Math.random().toString(36).substr(2, 9));

        return (
            <div id={venueBannerRandomID} className="venue-hero-banner">
                <div className="venue-hero-banner__loader">
                    <CircularProgress color="primary" />
                </div>
                <div className="venue-hero-banner__desktop-background">
                    {
                        (desktopVideo !== null && desktopVideo.src !== undefined) ?
                            (
                                <video id="hero_video_background" preload="metadata" muted autoPlay loop playsInline data-object-fit="cover">
                                    <source src={desktopVideo.src} type="video/mp4" />
                                </video>
                            ) :
                            (desktopImage !== null && desktopImage.src !== null) &&
                            <SitecoreImageField img={desktopImage}></SitecoreImageField>
                    }
                </div>
                <div className="venue-hero-banner__mobile-background">
                    {
                        (mobileVideo !== null && mobileVideo.src !== undefined) ?
                            (
                                <video id="hero_video_background" preload="metadata" muted autoPlay loop playsInline data-object-fit="cover">
                                    <source src={mobileVideo.src} type="video/mp4" />
                                </video>
                            ) :
                            (mobileImage !== null && mobileImage.src !== null) &&
                            <SitecoreImageField img={mobileImage}></SitecoreImageField>
                    }
                </div>
                <div className="venue-hero-banner__content">
                    <div className="venue-hero-banner__content__container">
                        <div className="venue-hero-banner__content__info">
                            {title !== null && <h1 className="venue-hero-banner__content__info__title">{title}</h1>}
                            {subtitle !== null && <p className="venue-hero-banner__content__info__subtitle">{subtitle}</p>}
                        </div>
                        <div className="venue-hero-banner__content__panel">
                            <div className="venue-hero-banner__content__panel__buttons-wrap">
                                {
                                    (cta1 !== null && cta1.url !== undefined) &&
                                        <SitecoreLinkField link={cta1} className="venue-hero__button-super button button--super">
                                            <svg className="icon button__arrow-right" width="14" height="12" focusable="false">
                                                <use xlinkHref="#icon-arrow-right"></use>
                                            </svg>
                                        </SitecoreLinkField>
                                }
                                {
                                    (cta2 !== null && cta2.url !== undefined) &&
                                        <SitecoreLinkField link={cta2} className="venue-hero__button-super button button--super">
                                            <svg className="icon button__arrow-right" width="14" height="12" focusable="false">
                                                <use xlinkHref="#icon-arrow-right"></use>
                                            </svg>
                                        </SitecoreLinkField>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="venue-hero-banner__content__scroll-wrapper">
                    <button onClick={() => {
                        const venueHeroBanner = document.getElementById(venueBannerRandomID);
                        const venueHeroBannerSize = venueHeroBanner.getBoundingClientRect();

                        window.scrollBy({
                            left: 0,
                            top: venueHeroBannerSize.bottom,
                            behavior: 'smooth'
                        });
                    }}>
                        <svg className="icon button__arrow-right" width="14" height="12" focusable="false">
                            <use xlinkHref="#icon-arrow-right"></use>
                        </svg>
                    </button>
                </div>
            </div>
        );
    }
}

export default FullSizeHeroBanner;
